import React from "react";
import { useLocation } from "react-router-dom";
import { Seo } from "../lib/seo";
import { ARAC_TOOLS } from "./Header";

const PRIVATE = [
  ["/patron", "Yönetim Paneli"],
  ["/firma-panel", "Firma Paneli"],
  ["/uyelik", "Üyelik Paneli"],
  ["/davetiye/", "Davetiye"],
  ["/odeme/", "Ödeme Sonucu"],
];

// Route-level defaults; page-level <Seo> overrides these.
export const RouteSeo = () => {
  const { pathname, search } = useLocation();
  const priv = PRIVATE.find(([p]) => pathname === p || pathname.startsWith(p.endsWith("/") ? p : `${p}/`));
  if (priv) return <Seo title={`${priv[1]} | DüğünSenin`} noindex />;
  if (pathname === "/araclar") {
    const tool = ARAC_TOOLS.find((t) => t.key === new URLSearchParams(search).get("arac"));
    return (
      <Seo
        title={tool ? `${tool.label} - Ücretsiz Düğün Planlama Aracı | DüğünSenin` : "Ücretsiz Düğün Planlama Araçları | DüğünSenin"}
        description={tool ? `${tool.desc} DüğünSenin'in ücretsiz ${tool.label.toLowerCase()} aracıyla düğün hazırlığınızı kolaylaştırın.` : "Davetli listesi, dijital davetiye, düğün ajandası, bütçe planlayıcı ve oturma planı: DüğünSenin'in ücretsiz düğün planlama araçlarıyla hazırlığınızı tek yerden yönetin."}
        canonical={tool ? `/araclar?arac=${tool.key}` : "/araclar"}
      />
    );
  }
  if (pathname === "/firma-kayit") {
    return (
      <Seo
        title="Ücretsiz Firma Kaydı - İşletmenizi Ekleyin | DüğünSenin"
        description="Düğün mekanınızı veya düğün firmanızı DüğünSenin'e ücretsiz kaydedin; çiftlerden teklif talebi alın, fotoğraflarınızı ve fiyatlarınızı yayınlayın."
        canonical="/firma-kayit"
      />
    );
  }
  return null;
};
